module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/logo_edge.a696722d3ec16b360e7320f022c959ba.svg";